import React from "react";
import { motion } from "framer-motion";
import logo from "../../assets/img/HEXA.png";

const SuspendedProject = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-6">
      <motion.div
        className="w-full max-w-2xl rounded-2xl border border-neutral-200 bg-white p-8 text-center shadow-xl"
        initial={{ opacity: 0, y: 24 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <img
          src={logo}
          alt="logo HEXA"
          className="mx-auto mb-6 w-24"
        />
        <h1 className="mb-4 text-2xl font-bold uppercase font-heading text-black">
          Servicio suspendido temporalmente
        </h1>
        <p className="mb-4 text-base leading-7 text-neutral-700 font-body">
          Queremos informarte que el acceso a este servicio ha sido suspendido
          temporalmente.
        </p>
        <p className="text-base leading-7 text-neutral-700 font-body">
          Para reactivar tu servicio sin inconvenientes, te invitamos a ponerte
          en contacto con tu ejecutivo de cuenta asignado, quien podrá
          orientarte y gestionar la reactivación de manera ágil.
        </p>
      </motion.div>
    </div>
  );
};

export default SuspendedProject;
